import { Component, ViewEncapsulation, ChangeDetectionStrategy, Inject, Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MtxUtilsModule } from '@ng-matero/extensions/utils';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/dialog';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/material/button';
import * as ɵngcc4 from '@angular/material/icon';
import * as ɵngcc5 from '@ng-matero/extensions/utils';

function MtxDialogComponent_h1_0_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function MtxDialogComponent_h1_0_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r4._onClose()); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "close");
    ɵngcc0.ɵɵelementEnd()();
} }
function MtxDialogComponent_h1_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵtemplate(4, MtxDialogComponent_h1_0_button_4_Template, 3, 0, "button", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 2, ɵngcc0.ɵɵpipeBind1(3, 4, ctx_r0.data.title)), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.data.showCloseIcon);
} }
function MtxDialogComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7)(1, "p");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵpipe(4, "toObservable");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, ɵngcc0.ɵɵpipeBind1(4, 3, ctx_r1.data.description)));
} }
function MtxDialogComponent_ng_container_3_ng_container_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵlistener("click", function MtxDialogComponent_ng_container_3_ng_container_2_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r13._onClick(btn_r6.onClick)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("color", btn_r6.color)("ngClass", btn_r6.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ɵngcc0.ɵɵpipeBind1(3, 5, btn_r6.text)), " ");
} }
function MtxDialogComponent_ng_container_3_ng_container_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function MtxDialogComponent_ng_container_3_ng_container_2_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r17._onClick(btn_r6.onClick)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("color", btn_r6.color)("ngClass", btn_r6.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ɵngcc0.ɵɵpipeBind1(3, 5, btn_r6.text)), " ");
} }
function MtxDialogComponent_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxDialogComponent_ng_container_3_ng_container_2_button_1_Template, 4, 7, "button", 11);
    ɵngcc0.ɵɵtemplate(2, MtxDialogComponent_ng_container_3_ng_container_2_button_2_Template, 4, 7, "button", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r6.focusInitial);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !btn_r6.focusInitial);
} }
function MtxDialogComponent_ng_container_3_ng_container_3_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 17);
    ɵngcc0.ɵɵlistener("click", function MtxDialogComponent_ng_container_3_ng_container_3_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r24._onClick(btn_r6.onClick)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("color", btn_r6.color)("ngClass", btn_r6.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ɵngcc0.ɵɵpipeBind1(3, 5, btn_r6.text)), " ");
} }
function MtxDialogComponent_ng_container_3_ng_container_3_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function MtxDialogComponent_ng_container_3_ng_container_3_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r30); const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r28._onClick(btn_r6.onClick)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("color", btn_r6.color)("ngClass", btn_r6.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ɵngcc0.ɵɵpipeBind1(3, 5, btn_r6.text)), " ");
} }
function MtxDialogComponent_ng_container_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxDialogComponent_ng_container_3_ng_container_3_button_1_Template, 4, 7, "button", 15);
    ɵngcc0.ɵɵtemplate(2, MtxDialogComponent_ng_container_3_ng_container_3_button_2_Template, 4, 7, "button", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r6.focusInitial);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !btn_r6.focusInitial);
} }
function MtxDialogComponent_ng_container_3_ng_container_4_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21);
    ɵngcc0.ɵɵlistener("click", function MtxDialogComponent_ng_container_3_ng_container_4_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r37); const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r35 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r35._onClick(btn_r6.onClick)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("color", btn_r6.color)("ngClass", btn_r6.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ɵngcc0.ɵɵpipeBind1(3, 5, btn_r6.text)), " ");
} }
function MtxDialogComponent_ng_container_3_ng_container_4_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r41 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 22);
    ɵngcc0.ɵɵlistener("click", function MtxDialogComponent_ng_container_3_ng_container_4_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r41); const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r39 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r39._onClick(btn_r6.onClick)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("color", btn_r6.color)("ngClass", btn_r6.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ɵngcc0.ɵɵpipeBind1(3, 5, btn_r6.text)), " ");
} }
function MtxDialogComponent_ng_container_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxDialogComponent_ng_container_3_ng_container_4_button_1_Template, 4, 7, "button", 19);
    ɵngcc0.ɵɵtemplate(2, MtxDialogComponent_ng_container_3_ng_container_4_button_2_Template, 4, 7, "button", 20);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r6.focusInitial);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !btn_r6.focusInitial);
} }
function MtxDialogComponent_ng_container_3_ng_container_5_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r48 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 25);
    ɵngcc0.ɵɵlistener("click", function MtxDialogComponent_ng_container_3_ng_container_5_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r48); const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r46 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r46._onClick(btn_r6.onClick)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("color", btn_r6.color)("ngClass", btn_r6.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ɵngcc0.ɵɵpipeBind1(3, 5, btn_r6.text)), " ");
} }
function MtxDialogComponent_ng_container_3_ng_container_5_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r52 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 26);
    ɵngcc0.ɵɵlistener("click", function MtxDialogComponent_ng_container_3_ng_container_5_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r52); const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r50 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r50._onClick(btn_r6.onClick)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("color", btn_r6.color)("ngClass", btn_r6.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ɵngcc0.ɵɵpipeBind1(3, 5, btn_r6.text)), " ");
} }
function MtxDialogComponent_ng_container_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxDialogComponent_ng_container_3_ng_container_5_button_1_Template, 4, 7, "button", 23);
    ɵngcc0.ɵɵtemplate(2, MtxDialogComponent_ng_container_3_ng_container_5_button_2_Template, 4, 7, "button", 24);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const btn_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r6.focusInitial);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !btn_r6.focusInitial);
} }
function MtxDialogComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0)(1, 8);
    ɵngcc0.ɵɵtemplate(2, MtxDialogComponent_ng_container_3_ng_container_2_Template, 3, 2, "ng-container", 9);
    ɵngcc0.ɵɵtemplate(3, MtxDialogComponent_ng_container_3_ng_container_3_Template, 3, 2, "ng-container", 9);
    ɵngcc0.ɵɵtemplate(4, MtxDialogComponent_ng_container_3_ng_container_4_Template, 3, 2, "ng-container", 9);
    ɵngcc0.ɵɵtemplate(5, MtxDialogComponent_ng_container_3_ng_container_5_Template, 3, 2, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd()();
} if (rf & 2) {
    const btn_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", btn_r6.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "raised");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "stroked");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "flat");
} }
class MtxDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    _onClick(fn) {
        if (fn) {
            fn.call(this);
        }
        this._onClose();
    }
    _onClose() {
        this.dialogRef.close();
    }
}
MtxDialogComponent.ɵfac = function MtxDialogComponent_Factory(t) { return new (t || MtxDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
MtxDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MtxDialogComponent, selectors: [["mtx-dialog"]], exportAs: ["mtxDialog"], decls: 4, vars: 3, consts: [["class", "mtx-dialog-title", 4, "ngIf"], ["class", "mtx-dialog-content", 4, "ngIf"], [1, "mtx-dialog-actions"], [4, "ngFor", "ngForOf"], [1, "mtx-dialog-title"], ["mat-icon-button", "", 3, "click", 4, "ngIf"], ["mat-icon-button", "", 3, "click"], [1, "mtx-dialog-content"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], ["mat-raised-button", "", "cdkFocusInitial", "", 3, "color", "ngClass", "click", 4, "ngIf"], ["mat-raised-button", "", 3, "color", "ngClass", "click", 4, "ngIf"], ["mat-raised-button", "", "cdkFocusInitial", "", 3, "color", "ngClass", "click"], ["mat-raised-button", "", 3, "color", "ngClass", "click"], ["mat-stroked-button", "", "cdkFocusInitial", "", 3, "color", "ngClass", "click", 4, "ngIf"], ["mat-stroked-button", "", 3, "color", "ngClass", "click", 4, "ngIf"], ["mat-stroked-button", "", "cdkFocusInitial", "", 3, "color", "ngClass", "click"], ["mat-stroked-button", "", 3, "color", "ngClass", "click"], ["mat-flat-button", "", "cdkFocusInitial", "", 3, "color", "ngClass", "click", 4, "ngIf"], ["mat-flat-button", "", 3, "color", "ngClass", "click", 4, "ngIf"], ["mat-flat-button", "", "cdkFocusInitial", "", 3, "color", "ngClass", "click"], ["mat-flat-button", "", 3, "color", "ngClass", "click"], ["mat-button", "", "cdkFocusInitial", "", 3, "color", "ngClass", "click", 4, "ngIf"], ["mat-button", "", 3, "color", "ngClass", "click", 4, "ngIf"], ["mat-button", "", "cdkFocusInitial", "", 3, "color", "ngClass", "click"], ["mat-button", "", 3, "color", "ngClass", "click"]], template: function MtxDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MtxDialogComponent_h1_0_Template, 5, 6, "h1", 0);
        ɵngcc0.ɵɵtemplate(1, MtxDialogComponent_div_1_Template, 5, 5, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, MtxDialogComponent_ng_container_3_Template, 6, 4, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.description);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.data.buttons);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc2.NgSwitchDefault, ɵngcc3.MatButton, ɵngcc4.MatIcon, ɵngcc2.AsyncPipe, ɵngcc5.MtxToObservablePipe], styles: [".mtx-dialog-title{display:flex;justify-content:space-between;align-items:center;margin:0 0 20px;font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mtx-dialog-content{display:block;max-height:65vh;padding:0 24px;margin:0 -24px;overflow:auto;-webkit-overflow-scrolling:touch}.mtx-dialog-actions{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;min-height:52px;padding:8px 0;margin-bottom:-24px}"], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
MtxDialogComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxDialogComponent, [{
        type: Component,
        args: [{ selector: 'mtx-dialog', exportAs: 'mtxDialog', template: "<h1 class=\"mtx-dialog-title\" *ngIf=\"data.title\">{{data.title | toObservable | async}}\n  <button mat-icon-button *ngIf=\"data.showCloseIcon\" (click)=\"_onClose()\">\n    <mat-icon>close</mat-icon>\n  </button>\n</h1>\n<div class=\"mtx-dialog-content\" *ngIf=\"data.description\">\n  <p>{{data.description | toObservable | async}}</p>\n</div>\n<div class=\"mtx-dialog-actions\">\n  <ng-container *ngFor=\"let btn of data.buttons\">\n    <ng-container [ngSwitch]=\"btn.type\">\n      <ng-container *ngSwitchCase=\"'raised'\">\n        <button mat-raised-button *ngIf=\"btn.focusInitial\" cdkFocusInitial\n                [color]=\"btn.color\" [ngClass]=\"btn.class\" (click)=\"_onClick(btn.onClick)\">\n          {{btn.text | toObservable | async}}\n        </button>\n        <button mat-raised-button *ngIf=\"!btn.focusInitial\"\n                [color]=\"btn.color\" [ngClass]=\"btn.class\" (click)=\"_onClick(btn.onClick)\">\n          {{btn.text | toObservable | async}}\n        </button>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'stroked'\">\n        <button mat-stroked-button *ngIf=\"btn.focusInitial\" cdkFocusInitial\n                [color]=\"btn.color\" [ngClass]=\"btn.class\" (click)=\"_onClick(btn.onClick)\">\n          {{btn.text | toObservable | async}}\n        </button>\n        <button mat-stroked-button *ngIf=\"!btn.focusInitial\"\n                [color]=\"btn.color\" [ngClass]=\"btn.class\" (click)=\"_onClick(btn.onClick)\">\n          {{btn.text | toObservable | async}}\n        </button>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'flat'\">\n        <button mat-flat-button *ngIf=\"btn.focusInitial\" cdkFocusInitial\n                [color]=\"btn.color\" [ngClass]=\"btn.class\" (click)=\"_onClick(btn.onClick)\">\n          {{btn.text | toObservable | async}}\n        </button>\n        <button mat-flat-button *ngIf=\"!btn.focusInitial\"\n                [color]=\"btn.color\" [ngClass]=\"btn.class\" (click)=\"_onClick(btn.onClick)\">\n          {{btn.text | toObservable | async}}\n        </button>\n      </ng-container>\n      <ng-container *ngSwitchDefault>\n        <button mat-button *ngIf=\"btn.focusInitial\" cdkFocusInitial\n                [color]=\"btn.color\" [ngClass]=\"btn.class\" (click)=\"_onClick(btn.onClick)\">\n          {{btn.text | toObservable | async}}\n        </button>\n        <button mat-button *ngIf=\"!btn.focusInitial\"\n                [color]=\"btn.color\" [ngClass]=\"btn.class\" (click)=\"_onClick(btn.onClick)\">\n          {{btn.text | toObservable | async}}\n        </button>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n</div>\n", encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, styles: [".mtx-dialog-title{display:flex;justify-content:space-between;align-items:center;margin:0 0 20px;font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mtx-dialog-content{display:block;max-height:65vh;padding:0 24px;margin:0 -24px;overflow:auto;-webkit-overflow-scrolling:touch}.mtx-dialog-actions{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;min-height:52px;padding:8px 0;margin-bottom:-24px}"] }]
    }], function () { return [{ type: ɵngcc1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

const ɵ0 = () => { }, ɵ1 = () => { };
const defaults = {
    title: '',
    description: '',
    buttons: [
        {
            color: 'warn',
            text: 'OK',
            focusInitial: true,
            onClick: ɵ0,
        },
        {
            text: 'CLOSE',
            onClick: ɵ1,
        },
    ],
    showCloseIcon: false,
    disableClose: true,
    width: '300px',
};
class MtxDialog {
    constructor(dialog) {
        this.dialog = dialog;
    }
    originalOpen(componentOrTemplateRef = MtxDialogComponent, config) {
        return this.dialog.open(componentOrTemplateRef, config);
    }
    open(config, componentOrTemplateRef = MtxDialogComponent) {
        const data = Object.assign({}, defaults, config);
        return this.dialog.open(componentOrTemplateRef, Object.assign(Object.assign({}, data), { data }));
    }
    alert(title, description = '', onOk = () => { }) {
        this.open({
            title,
            description,
            buttons: [
                {
                    color: 'warn',
                    text: 'OK',
                    onClick: () => onOk(),
                },
            ],
        });
    }
    confirm(title, description = '', onOk = () => { }, onClose = () => { }) {
        this.open({
            title,
            description,
            buttons: [
                {
                    color: 'warn',
                    text: 'OK',
                    onClick: () => onOk(),
                },
                {
                    text: 'CLOSE',
                    onClick: () => onClose(),
                },
            ],
        });
    }
}
MtxDialog.ɵfac = function MtxDialog_Factory(t) { return new (t || MtxDialog)(ɵngcc0.ɵɵinject(ɵngcc1.MatDialog)); };
MtxDialog.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MtxDialog, factory: MtxDialog.ɵfac });
/** @nocollapse */
MtxDialog.ctorParameters = () => [
    { type: MatDialog }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxDialog, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.MatDialog }]; }, null); })();

class MtxDialogModule {
}
MtxDialogModule.ɵfac = function MtxDialogModule_Factory(t) { return new (t || MtxDialogModule)(); };
MtxDialogModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MtxDialogModule });
MtxDialogModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [MtxDialog], imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MtxUtilsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxDialogModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MtxUtilsModule],
                exports: [MtxDialogComponent],
                declarations: [MtxDialogComponent],
                providers: [MtxDialog],
                entryComponents: [MtxDialogComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtxDialogModule, { declarations: function () { return [MtxDialogComponent]; }, imports: function () { return [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MtxUtilsModule]; }, exports: function () { return [MtxDialogComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MtxDialog, MtxDialogComponent, MtxDialogModule, ɵ0, ɵ1 };

